<div
  class="dialog-header"
  style="display: flex; flex-wrap: wrap; justify-content: space-between"
>
  <h6 matDialogTitle>Feature Selection</h6>
  <button
    id="closebtn"
    class="close-button"
    bciprimarybutton
    tabindex="-1"
    (click)="close(false)"
  >
    <i class="Bosch-Ic Bosch-Ic-abort" aria-hidden="true"></i>
  </button>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
  <form [formGroup]="formData" #formDirective="ngForm" novalidate>
    <div class="row">
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <mat-label class="label-input">Modification type:</mat-label>
      </div>
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
        <mat-form-field>
          <mat-select
            formControlName="modificationTypeCtr"
            [(ngModel)]="model.selectedModificationType"
            (ngModelChange)="onModificationTypeChange()"
            ngDefaultControl
          >
            <mat-option
              *ngFor="let item of modificationType"
              [value]="item.value"
              >{{ item.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
        <mat-form-field>
          <input
            matInput
            type="text"
            ngDefaultControl
            (keyup)="search($event.target.value)"
            placeholder="Filter by Feature Name"
          />
          <mat-icon
            matSuffix
            fontIcon="Bosch-Ic-search"
            style="height: 40px"
          ></mat-icon>
        </mat-form-field>
      </div>

      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 alignTop">
        <mat-checkbox
          formControlName="displayCtr"
          ngDefaultControl
          [(ngModel)]="model.displayAll"
          (change)="onDisplayCheckChange($event)"
        >
          display all</mat-checkbox
        >
      </div>
    </div>

    <div class="row">
      <mat-table #tableFeature [dataSource]="featuresDataSource" matSort>
        <ng-container matColumnDef="index">
          <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
          <mat-cell *matCellDef="let item; let rindex = index">{{
            rindex + 1
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="selected">
          <mat-header-cell *matHeaderCellDef>Select</mat-header-cell>
          <mat-cell *matCellDef="let item">
            <mat-checkbox
              [(ngModel)]="item.selected"
              [ngModelOptions]="{ standalone: true }"
              [checked]="item.selected"
              (change)="onChangeFeature()"
            ></mat-checkbox>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="modificationType">
          <mat-header-cell *matHeaderCellDef>Modification Type</mat-header-cell>
          <mat-cell *matCellDef="let item">{{
            item.modificationTypeString
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="featureName">
          <mat-header-cell *matHeaderCellDef>Feature Name</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.name }}</mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let item; columns: displayedColumns"></mat-row>
      </mat-table>
      <mat-paginator #paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 20]">
      </mat-paginator>
    </div>
    <div class="pull-right">
      <mat-label>Selected:{{ countSelected }}</mat-label>
    </div>
  </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-footer>
  <div class="pull-right" style="margin: 1em">
    <button
      type="button"
      id="clearbtn"
      bciprimarybutton
      class="button-primary"
      (click)="reset($event)"
      style="margin-right: 3px"
    >
      Clear
    </button>
    &nbsp;
    <button
      type="button"
      id="savebtn"
      bciprimarybutton
      class="button-primary"
      [disabled]="!formData.valid"
      (click)="save()"
    >
      Save
    </button>
    &nbsp;
    <button
      type="button"
      id="cancelbtn"
      bciprimarybutton
      class="button-primary"
      [disabled]="!formData.valid"
      (click)="close(false)"
    >
      Cancel
    </button>
  </div>
</mat-dialog-footer>
